import templateUrl from './emp-portal.component.html';
import { ReviewModal } from '../../review-modal/review-modal.component';
import { IcdOfficeService } from '../../../../core/services/data-services/icd-office.service';
import { InfoModal } from '../../info-modal/info-modal.component';
//import { ApexOwnerModal } from '../../owner-modal/owner-modal.component';

export const EmpPortalComponent = {
    templateUrl,
    controller: EmpPortalController,
    controllerAs: "vm",
    bindings: {
        employee: "<",
        userRole: "<",
        employeeBankInfo: "<",
        permissionGrants: "<",
        onboardingAccess: "<",
        modalTitle: "<",
        icdOffices: "<",
        stateProvinces: "<"
        //closeModal: "&"
    }
};

export enum OnbTabs {
    All = 0,
    Active = 1,
    Pending = 2,
    Terminated = 3,
    Self = 4
}

function EmpPortalController(utilityService, employeeService, $state, $q,
    onboardingDocumentService, $uibModal, $transitions, icdOfficeService: IcdOfficeService, $timeout) {
    'ngInject';
    const vm = this;
    let defaultFilter;
    vm.applications = [];
    vm.applicationsbk = [];
    vm.activeTab = 'Active';
    vm.pageNumber = 1;
    vm.pageSize = 15;
    vm.maxSize = 15;
    vm.totalItems = vm.applications.length;
    vm.allComments = [];
    vm.onComment = onComment;
    vm.approveApplication = approveApplication;
    vm.removeApplication = removeApplication;
    vm.getButtonTitle = getButtonTitle;
    vm.showAddModal = showAddModal;
    vm.approveApplicationForPaper = approveApplicationForPaper;
    vm.triggerOnboardingForInactive = triggerOnboardingForInactive;
    vm.changeToPaper = changeToPaper
    vm.changeToOnline = changeToOnline
    vm.navigateToLegacyProfile = navigateToLegacyProfile;
    vm.icdOfficeID;
    vm.activeTabIndex = 0;
    vm.isLoaded;
    vm.isComment = false;
    vm.isChangeRequested = false;
    vm.isEmployerView = false;
    //vm.updateFilteredApplications = updateFilteredApplications;
    vm.onChangeTab = onChangeTab;
    vm.onClearClicked = onClearClicked;
    //vm.activeTab = 'Active'
    //const ROSTER_MODULE = SiteModuleEnum.Roster;
    vm.statusDD = [{ id: 'Created', value: 'Created' }, { id: 'Started', value: 'Started' }, { id: 'Approved', value: 'Approved' }, { id: 'Review', value: 'Review' }, { id: 'Submitted', value: 'Submitted' }, { id: 'Deleted', value: 'Deleted' }];

    vm.saveComment = saveComment;
    vm.fillEmployer = fillEmployer;
    vm.requestChangesModal = requestChangesModal;

    vm.applicationId;
    vm.selectedApplication;
    vm.filters = {};
    vm.filtersRestored;
    vm.onChangeFilters = onChangeFilters;
    vm.terminateApplication = terminateApplication;
    vm.clearDate = clearDate;
    vm.fillApplication = fillApplication;
    vm.checkApplication = checkApplication;
    vm.resendOnboardingEmail = resendOnboardingEmail;
    vm.isSortingByField = isSortingByField;
    vm.onToggleShowAll = onToggleShowAll;
    //vm.getSubmittedFormOwner = getSubmittedFormOwner;
    // variables to manage buttons
    vm.clearFilter = clearFilter;
    vm.sortColumn = { field: "ApplicationNumber", dir: 1 };
    vm.columnClass = columnClass;
    vm.onSetSort = onSetSort;
    vm.onChangePage = onChangePage;
    vm.rehireEmployee = rehireEmployee;
    vm.sortData = sortData;
    vm.enabledRequestChanges = false;
    vm.enabledApprove = false;
    vm.enableFillEmployer = false;
    vm.enableCreate;
    vm.updateEmployee = updateEmployee;
    vm.onboardEmployee = onboardEmployee;
    vm.enableCreateOnb = false;
    vm.showAll = false;
    vm.rejectApplication = rejectApplication;


    vm.paginatedApplications = function () {
        var begin = ((vm.currentPage - 1) * vm.pageSize);
        var end = begin + vm.pageSize;
        return vm.applications.slice(begin, end);
    };

    vm.$onInit = function () {
        //utilityService.showLoading();
        defaultFilter = {};
        vm.userName = this.employee.UserName;

        defaultFilter.PageNumber = vm.pageNumber;
        defaultFilter.PageSize = vm.pageSize;
        defaultFilter.PageNumberA = vm.pageNumber;
        defaultFilter.PageSizeA = vm.pageSize;
        defaultFilter.PageNumberT = vm.pageNumber;
        defaultFilter.PageSizeT = vm.pageSize;
        defaultFilter.PageNumberP = vm.pageNumber;
        defaultFilter.PageSizeP = vm.pageSize;
        defaultFilter.PageNumberS = vm.pageNumber;
        defaultFilter.PageSizeS = vm.pageSize;

        vm.usrRole = this.userRole;
        vm.isOwner = this.userRole === 'Owner' || this.userRole === 'PayrollAdmin';
        vm.isEmployee = this.userRole === 'Employee';
        vm.enableCreateOnb = vm.onboardingAccess && vm.onboardingAccess.CanCreate;

        const filtersRestored = restoreFilters();
        const promises = [];
        promises.push(filtersRestored);
        promises.push(loadApplications(OnbTabs.All));
        // Everyone (incl. plain employees) gets their own employee profile on the Self tab.
        promises.push(loadApplications(OnbTabs.Self));
        if (vm.isOwner) {
            promises.push(loadApplications(OnbTabs.Active));

            promises.push(loadApplications(OnbTabs.Pending));
            promises.push(loadApplications(OnbTabs.Terminated));
        }

        if (vm.isOwner) {
            $q.all(loadIcdOffices());
        }
        //vm.filtersRestored = restoreFilters();
        var tabNames = ['All', 'Active', 'Pending', 'Terminated', 'Self'];
        vm.activeTabIndex = getActiveTab();
        vm.activeTab = tabNames[vm.activeTabIndex];
        onChangeTab(vm.activeTabIndex);
        const initLoad = $q.all(promises).then((res) => {
            console.log(res);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(initLoad), "Changing page failed");
        //$q.all([promises]).then((data) => {
        //    utilityService.hideLoading();
        //}).catch((err) => {
        //    utilityService.hideLoading();
        //    alert("Loading Failed: " + utilityService.getExceptionMessage(err));
        //});
    }

    function resendOnboardingEmail(employeeId) {
        utilityService.showLoading();
        return employeeService.resendOnboardingEmployee(employeeId).then((res) => {
            utilityService.hideLoading();
            alert("Email sent successfully");
        }).catch((err) => {
            utilityService.hideLoading();
            alert("Sending Email Failed: " + utilityService.getExceptionMessage(err));
        });
    }

    function changeToPaper(application) {
        $uibModal.open({
            ...InfoModal,
            resolve: {
                notification: () => "You're about to switch this profile to a paper application. You will need to ensure that paper copies are kept with your organization for 7 years. Would you like to continue?",
                cancel: () => "Cancel",
                continue: () => "Proceed",
                state: () => "application-status"
            },
            controller: function ConfirmModalController($uibModalInstance) {
                'ngInject'
                this.close = function () {
                    $uibModalInstance.dismiss();
                };
            },
            size: 'sm',
            backdrop: 'static'
        }).result.then(function (data) {
            console.log(data);
            if (data === 'ok') {
                const change = onboardingDocumentService.changeApplicationToPaper(application.ApplicationNumber);
                change.then((res) => {
                    console.log(res);
                    return navigateToLegacyProfile(application.EmployeeId);
                });
                utilityService.showLoadingUntilResolved(
                    utilityService.alertOnError(change), "Changing application type failed"
                );
            }
        }, function (dismiss) {
            console.log('dismissed');
        });
    }
    function terminateApplication(appNo) {
        $state.go('application-status.termination', { appId: appNo });
    }

    function rejectApplication(app) {
        if (app.IsTelemapperLinked) {
            alert('Please be aware that your company is linked with Telemapper and terminations have to be processed in Telemapper.');
        } else {
            if (app.ApplicationStatus === 'Created') {
                var confirmDelete = confirm("Please confirm that you would like to terminate this onboarding application.");

                if (!confirmDelete) {
                    return; // cancel the action
                }

                // delete profile
                return terminateApplication(app.ApplicationNumber);
            } else {
                return terminateApplication(app.ApplicationNumber);
            }
        }
    }


    function navigateToLegacyProfile(employeeID) {
        return $state.go("employee.edit", {
            employeeID: employeeID
        });
    }

    function changeToOnline(application) {
        //const change = onboardingDocumentService.changeApplicationToOnline(application.ApplicationNumber).then((res) => {
        //    console.log(res);
        //});
        //utilityService.showLoadingUntilResolved(
        //    utilityService.alertOnError(change), "Changing page failed");


        $uibModal.open({
            ...InfoModal,
            resolve: {
                notification: () => "You're about to switch this profile to an online application. Would you like to continue?",
                cancel: () => "Cancel",
                continue: () => "Proceed",
                state: () => "application-status"
            },
            controller: function ConfirmModalController($uibModalInstance) {
                'ngInject'
                this.close = function () {
                    $uibModalInstance.dismiss();
                };
            },
            size: 'sm',
            backdrop: 'static'
        }).result.then(function (data) {
            console.log(data);
            if (data === 'ok') {
                const change = onboardingDocumentService.changeApplicationToOnline(application.ApplicationNumber);
                change.then((res) => {
                    console.log(res);
                    if (res) {
                        $state.reload();
                    }
                    /* return navigateToLegacyProfile(application.EmployeeId);*/
                });
                utilityService.showLoadingUntilResolved(
                    utilityService.alertOnError(change), "Changing application type failed"
                );
            }
        }, function (dismiss) {
            console.log('dismissed');
        });
    }

    function onToggleShowAll(showAll) {
        vm.filters.showAll = showAll;
        const promises = [];
        promises.push(loadApplications(OnbTabs.All));
        promises.push(loadApplications(OnbTabs.Self));
        if (vm.isOwner) {
            promises.push(loadApplications(OnbTabs.Active));
            promises.push(loadApplications(OnbTabs.Pending));
            promises.push(loadApplications(OnbTabs.Terminated));
        }
        const initLoad = $q.all(promises).then((res) => {
            console.log(res);
        });
        saveFilters();
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(initLoad), "Changing page failed");
    }

    function onClearClicked() {
        localStorage.removeItem("listonboardlistFilters");
        clearFilter();
    }

    function onboardEmployee(employeeId) {
        $state.go('application-status.pendingModal', { employeeId: employeeId, icdOfficeID: vm.icdOfficeID, onboard: true })
            .catch(function (err) {
                // navigation failed
                console.log(err);
                alert("Failed to onboard employee" + err);
            });
    }

    function updateEmployee(employeeId) {
        //$uibModal.open({
        //    ...InfoModal,
        //    resolve: {
        //        notification: () => "Changing the employee profile requires the required forms to be re-signed. Would you like to continue?",
        //        cancel: () => "Cancel",
        //        continue: () => "Proceed",
        //        state: () => "application-status.pendingModal",
        //        params: () => ({ employeeId: employeeId, icdOfficeID: vm.icdOfficeID })
        //    },
        //    controller: function ConfirmModalController($uibModalInstance) {
        //        'ngInject'
        //        this.close = function () {
        //            $uibModalInstance.dismiss();
        //        };
        //    },
        //    size: 'sm',
        //    backdrop: 'static'
        //}).result.then(function (data) {
        //    console.log(data);
        //    //if (data === 'ok') {
        //    //    $state.go('application-status.pendingModal', {
        //    //        employeeId: employeeId,
        //    //        icdOfficeID: vm.icdOfficeID
        //    //    });
        //    //}
        //}, function (dismiss) {
        //    console.log('dismissed');
        //});

        //if (confirm("Are you sure you want to update this employee?")) {
        //    $state.go('application-status.pendingModal', {
        //        employeeId: employeeId,
        //        icdOfficeID: vm.icdOfficeID
        //    });
        //}
        $state.go('application-status.pendingModal', { employeeId: employeeId, icdOfficeID: vm.icdOfficeID });
    }

    function loadApplications(active) {
        let query = {
            PageSize: vm.filters.PageSize,
            UserName: vm.employee.UserName,
            Id: vm.filters.applicationNumber,
            EmployeeName: vm.filters.employeeName,
            OwnerName: vm.filters.owner,
            UserProfile: vm.filters.userProfile,
            FedW4W9: vm.filters.federalW4,
            ProvinceW4: vm.filters.stateW4,
            I9: vm.filters.i9,
            DirectDeposit: vm.filters.directDeposit,
            ProfileStatus: vm.filters.status,
            AccountStatus: vm.filters.employeeStatus,
            Department: vm.filters.dept,
            SortFields: vm.filters.SortFields,
            ShowAll: true,
            EmployeeStatus: 0
        };
        let pageNum = vm.filters.PageNumber;
        if (active === OnbTabs.Active) {
            query.EmployeeStatus = 1;
            pageNum = vm.filters.PageNumberA;
        } else if (active === OnbTabs.Pending) {
            query.EmployeeStatus = 2;
            pageNum = vm.filters.PageNumberP;
        } else if (active === OnbTabs.Terminated) {
            query.EmployeeStatus = 3;
            pageNum = vm.filters.PageNumberT;
        } else if (active === OnbTabs.Self) {
            query.EmployeeStatus = 4
            pageNum = vm.filters.PageNumberS
        } else {
            query.EmployeeStatus = 0;
            pageNum = vm.filters.PageNumber
        }
        return loadApplicationsPage(query, pageNum).then(function (page) {

            if (active === OnbTabs.Active) {
                vm.applicationsPageAct = page;
                vm.applicationsAct = page.Entities;
            } else if (active === OnbTabs.Pending) {
                vm.applicationsPagePen = page;
                vm.applicationsPen = page.Entities;
            } else if (active === OnbTabs.Terminated) {
                vm.applicationsPageTerm = page;
                vm.applicationsTerm = page.Entities;
            } else if (active === OnbTabs.Self) {
                var matching = page.Entities.filter(app => app.EmployeeId === vm.employee.EmployeeID);
                if (matching) {
                    vm.isSelf = true;
                }
                vm.applicationsPageSelf = page;
                vm.applicationsSelf = page.Entities;

            } else {
                vm.applicationsPage = page;
                vm.applications = page.Entities;
            }
            vm.isLoaded = true;
        });
    }



    function onChangeTab(tab) {
        /*vm.filterDocs = vm.applicationsbk;*/
        vm.activeTab = tab;

        vm.filters.PageNumber = 1;
        vm.filters.PageNumberA = 1;
        vm.filters.PageNumberP = 1;
        vm.filters.PageNumberT = 1;
        vm.filters.PageNumberS = 1;
        //clearFilter();
        saveActiveTab();
        //restoreFilters();

        const loadJob = loadApplications(vm.activeTab);
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadJob), "Changing page failed");
    }

    function onChangePage() {
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadApplications(vm.activeTab), "Changing page failed"));
        saveFilters();
    }

    function clearFilter() {
        vm.filters.applicationNumber = '';
        vm.filters.startDate = null;
        vm.filters.endDate = null;
        vm.filters.createdBy = '';
        vm.filters.owner = '';
        vm.filters.status = '';
        vm.filters.employeeName = '';
        vm.filters.userProfile = '';
        vm.filters.federalW4 = '';
        vm.filters.stateW4 = '';
        vm.filters.i9 = '';
        vm.filters.directDeposit = '';
        vm.filters.employeeStatus = '';
        vm.filters.dept = '';
        vm.filters.showAll = false;
        //vm.filterDocs = vm.applicationsbk;
        //if (vm.activeTab === 'Pending') {
        //    vm.filterDocs = vm.filterDocs.filter(x => x.EmployeeStatus.includes('Pending'))
        //} else if (vm.activeTab === 'Active') {
        //    vm.filterDocs = vm.filterDocs.filter(x => x.EmployeeStatus.includes('Active'))
        //} else if (vm.activeTab === 'Terminated') {
        //    vm.filterDocs = vm.filterDocs.filter(x => x.EmployeeStatus.includes('Terminated'))
        //} else {
        //    vm.filterDocs = vm.filterDocs
        //}
        //vm.applications = vm.filterDocs;
    }

    function columnClass(field) {
        return vm.sortColumn.dir === -1 ? "fas fa-sort-amount-down" : "fas fa-sort-amount-down-alt";
    }

    function isSortingByField(field) {
        return vm.sortColumn.field === field
    }

    function triggerOnboardingForInactive(employeeId) {
        const init = employeeService.initOnboardingEmployee(employeeId, true).then((res) => {
            console.log(res);
            return loadApplications(vm.activeTab);
        }).then(() => {
            console.log("Success");
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(init, "Error Initiating Onboarding"));
    }

    function onSetSort(field) {
        if (!vm.filters) {
            vm.filters = {}; // Initialize filters if not already defined
        }
        if (!vm.filters.SortFields) {
            vm.filters.SortFields = []; // Initialize SortFields if not already defined
        }
        if (vm.isSortingByField(field)) {
            vm.sortColumn.dir = vm.sortColumn.dir * -1;
        } else {

            vm.sortColumn.dir = 1;
        }
        vm.sortColumn.field = field;
        vm.filters.SortFields = [(vm.sortColumn.dir === -1 ? "-" : "") + field];
        /*vm.sortData();*/
        saveFilters();
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([loadApplications(OnbTabs.All), loadApplications(OnbTabs.Active), loadApplications(OnbTabs.Terminated), loadApplications(OnbTabs.Pending), loadApplications(OnbTabs.Self)]), "Sorting Failed"));
    }

    function saveFilters() {
        localStorage.setItem("listonboardlistFilters", JSON.stringify(vm.filters || {}));
    }

    function rehireEmployee(employeeID) {
        $state.go('application-status.pendingModal', { employeeId: employeeID, icdOfficeID: vm.icdOfficeID, rehire: true });
    }

    function restoreFilters() {
        // Restore filters to the grid from localStorage, if available.
        vm.filters = JSON.parse(localStorage.getItem("listonboardlistFilters")) || defaultFilter;
        // Set default page index and size if they don't exist already.
        vm.filters.PageNumber = vm.filters.PageNumber || vm.pageNumber;
        vm.filters.PageSize = vm.filters.PageSize || vm.pageSize;
        vm.filters.PageNumberA = vm.filters.PageNumberA || vm.pageNumber;
        vm.filters.PageSizeA = vm.filters.PageSizeA || vm.pageSize;
        vm.filters.PageNumberT = vm.filters.PageNumberT || vm.pageNumber;
        vm.filters.PageSizeT = vm.filters.PageSizeT || vm.pageSize;
        vm.filters.PageNumberP = vm.filters.PageNumberP || vm.pageNumber;
        vm.filters.PageSizeP = vm.filters.PageSizeP || vm.pageSize;

        vm.filters.showAll = vm.filters.showAll || false;
        vm.filters.PageNumberS = vm.filters.PageNumberS || vm.pageNumber;
        vm.filters.PageSizeS = vm.filters.PageSizeP || vm.pageSize;
        if (vm.filters.SortFields && vm.filters.SortFields.length > 0) {
            // Check the first character of the first sort.
            vm.sortDirection = vm.filters.SortFields[0][0] === "-" ? -1 : 1;
            vm.sortField = vm.filters.SortFields[0].replace("-", "");
            // Keep sortColumn (drives the onSetSort toggle + header indicator) in sync with
            // the restored sort, otherwise the first click after a reload fails to toggle.
            vm.sortColumn = { field: vm.sortField, dir: vm.sortDirection };
        }
        //onChangeFilters();
        return $q.when();
    }

    function sortData() {
        if (!vm.sortColumn.field) return;

        const field = vm.sortColumn.field;
        const dir = vm.sortColumn.dir;

        vm.filterDocs.sort((a, b) => {
            const valA = a[field];
            const valB = b[field];

            if (valA < valB) return dir * -1;
            if (valA > valB) return dir * 1;
            return 0;
        });

        vm.applications = vm.filterDocs;
        vm.totalItems = vm.applications.length;
    }

    function saveActiveTab() {
        localStorage.setItem("empPortalTabIndex", vm.activeTabIndex || 0);
    }

    function getActiveTab() {
        // Plain employees only have the Self tab, so default them there (All is hidden for them).
        return vm.isEmployee ? OnbTabs.Self : (Number(localStorage.getItem("empPortalTabIndex") || 0));
    }


    function loadIcdOffices() {
        if (!vm.isOwner) {
            return;
        }
        // Disable features if the user can't perform them for all offices.
        const missingCrud = vm.icdOffices.reduce(function (any, office) {
            return any || !office.CanUpdate || !office.CanCreate || !office.CanDelete;
        }, false);

        // To simplify logic, disable the "all offices" filter and pre-select the most permissive office by default.
        if ((missingCrud || vm.icdOffices.length === 1) && vm.icdOffices[0]) {
            vm.icdOfficeID = vm.icdOffices[0].Id;
            vm.enableCreate = vm.icdOffices[0].CanCreate;
        } else {
            // Clear the filtered office ID if the office doesn't appear in the list. Treat it as unselected.
            vm.icdOfficeID = null;
            vm.enableCreate = true;
        }

    }

    //function isValidIcdFilter(filters, icdOffices) {
    //    return (filters && !filters.icdOfficeID) || icdOffices.some(p => p.Id === filters.icdOfficeID);
    //}



    function fillEmployer(application: any) {
        //return $state.go("application-status.ownermodal");
        /*utilityService.showLoading();*/
        $state.go("application-status.ownermodal", {
            applicationId: application.ApplicationId,
            employeeId: application.EmployeeId
        });
    }

    //section
    function loadApplicationsPage(query, pageNumber) {
        return onboardingDocumentService.retrieveApplicationPage(pageNumber - 1, query)
    }

    //end section


    function showAddModal() {
        $state.go('application-status.pendingModal', { icdOfficeID: vm.icdOfficeID });
    }



    function getButtonTitle(requestTypeId, app) {

        switch (requestTypeId) {
            case "6":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.UserProfile === 'Review' || app.UserProfile === 'Submitted') ? "Update" : "Fill";
            case "5":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.FederalW4 === 'Review' || app.FederalW4 === 'Submitted') ? "Update" : "Fill";
            case "-2":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.W9 === 'Review' || app.W9 === 'Submitted') ? "Update" : "Fill";
            case "2":

                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.ProvinceW4 === 'Review' || app.ProvinceW4 === 'Submitted') ? "Update" : "Fill";
            case "3":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.I9Form === 'Review' || app.I9Form === 'Submitted') ? "Update" : "Fill";
            case "7":
                return app.ApplicationStatus === 'Submitted' ? "View" : (app.DirectDeposit === 'Review' || app.DirectDeposit === 'Submitted' || app.ApplicationStatus === 'Approved') ? "Update" : "Fill";
            case "confirmation":
                return "";
        }
    }

    function fillApplication(requestTypeId: string, application: any) {
        switch (requestTypeId) {
            case "6":
                $state.go("application-status.profile");
                break;
            case "5":
                $state.go("application-status.federalW4");
                break;
            case "-2":
                $state.go("application-status.w9");
                break;
            case "2":
                $state.go("application-status.provinceW4");
                break;
            case "3":
                $state.go("application-status.i9");
                break;
            case "7":
                $state.go("application-status.dd");
                break;
            case "confirmation":
                $state.go("application-status.confirmation");
                break;
        }
    }

    function checkApplication(requestTypeId: string, application: any) {
        /*    var taxState = vm.employeeBankInfo.StateToBeTaxedIn ?? 0;*/
        switch (requestTypeId) {
            case "6":
                $state.go("application-status.owner-profile", { applicationId: application.ApplicationNumber });
                break;
            case "5":
                $state.go("application-status.owner-federalW4-preview", { applicationId: application.ApplicationNumber });
                break;
            case "-2":
                $state.go("application-status.owner-w9-preview", { applicationId: application.ApplicationNumber });
                break;
            case "2":
                switch (application.StateTaxedIn) {
                    case 9:
                        $state.go("application-status.owner-provinceW4", { applicationId: application.ApplicationNumber });
                        break;
                    default:
                        $state.go("application-status.owner-provinceW4-preview", { applicationId: application.ApplicationNumber });
                        break;
                }
                break;
            case "3":
                $state.go("application-status.owner-i9", { applicationId: application.ApplicationNumber });
                break;
            case "7":
                $state.go("application-status.owner-dd", { applicationId: application.ApplicationNumber });
                break;
            case "confirmation":
                $state.go("application-status.confirmation");
                break;
        }
    }

    function approveApplicationForPaper(requestTypeId: string, application: any) {
        console.log(requestTypeId);
        if (!application.ProvinceW4ExemptChoice) {
            alert("The tax form will be coming in the future. Until then, please ensure that you are completing the paper form outside of Apex.");
        }
        return $state.go("application-status.owner-provinceW4-preview", { applicationId: application.ApplicationNumber });
    }

    function clearDate(fieldId) {
        console.log(fieldId)
        var datePicker = $("#" + fieldId).data("kendoDatePicker");
        if (datePicker) {
            datePicker.value(null); // Clear the date
            if (fieldId === "StartDate") {
                vm.filters.startDate = null;
            }
            if (fieldId === "EndDate") {
                vm.filters.endDate = null;
            }
        }
        onChangeFilters();
    }

    $transitions.onSuccess({ to: 'application' }, function () {
        console.log('load stop');
        utilityService.hideLoading();
    });

    let onChangeFiltersTimer;
    function onChangeFilters() {
        if (onChangeFiltersTimer) $timeout.cancel(onChangeFiltersTimer);
        onChangeFiltersTimer = $timeout(function () {
            vm.filters.PageNumber = 1;
            vm.filters.PageNumberA = 1;
            vm.filters.PageNumberT = 1;
            vm.filters.PageNumberP = 1;
            vm.filters.PageNumberS = 1;
            saveFilters();
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError($q.all([loadApplications(OnbTabs.All), loadApplications(OnbTabs.Active), loadApplications(OnbTabs.Terminated), loadApplications(OnbTabs.Pending), loadApplications(OnbTabs.Self)]), "Filtering failed"));
        }, 300);
    }

    function requestChangesModal(application: any) {
        utilityService.showLoading();
        var prom2 = employeeService.retrieveEmployeeBankInfo(application.EmployeeId);
        let prom1 = onboardingDocumentService.retrieveComments(application.ApplicationId);
        $q.all([prom1, prom2])
            .then(function (result) {
                utilityService.hideLoading();
                return $uibModal.open({
                    ...ReviewModal,
                    resolve: {
                        title: () => "Review Request",
                        allComments: () => result[0],
                        stateProvince: () => result[1],
                        application: () => application,
                        employee: () => vm.employee
                    }
                }).result
                //vm.allComments[0] = result;
                //vm.isChangeRequested = true;
                //vm.applicationId = application.ApplicationId;
                //vm.selectedApplication = application;
                //console.log(vm.selectedApplication);
                //return result;
            }).catch((err) => {
                utilityService.hideLoading();
                alert("Loading Changes Modal Failed: " + utilityService.getExceptionMessage(err));
            })

    }



    function onComment(applicationId) {
        utilityService.showLoading();
        $state.go('application-status.comments', {
            appId: applicationId,
            userName: vm.employee.UserName
        });

        //vm.isComment = true;
        //vm.applicationId = applicationId;

        //onboardingDocumentService.retrieveComments(vm.applicationId)
        //    .then(function (result) {
        //        vm.allComments[0] = result;
        //        utilityService.hideLoading();
        //        return result;
        //    })
        //    .catch((err) => {
        //        utilityService.hideLoading();
        //        alert("Loading Comment Failed: " + utilityService.getExceptionMessage(err));
        //    })
    }

    function approveApplication(applicationId: any, employeeId: any) {
        utilityService.showLoading();
        vm.applicationId = applicationId;

        onboardingDocumentService.approveApplication(employeeId)
            .then(function (result) {
                vm.allComments[0] = result;
                sessionStorage.removeItem('apexNavigation');
                window.location.reload();
                utilityService.hideLoading();
                /*return result;*/
            }).catch((err) => {
                utilityService.hideLoading();
                alert("Approval Failed: " + utilityService.getExceptionMessage(err));
            })
    }
    //decommissioned
    function removeApplication(applicationId: any) {
        utilityService.showLoading();
        vm.applicationId = applicationId;

        onboardingDocumentService.removeApplication(vm.applicationId)
            .then(function (result) {
                //vm.allComments[0] = result;
                utilityService.hideLoading();
                return result;
            }).then(function (res) {
                if (res) {
                    $state.reload();
                }
            }).catch((err) => {
                utilityService.hideLoading();
                alert("Remove Failed: " + utilityService.getExceptionMessage(err));
            })
    }



    function saveComment() {
        utilityService.showLoading();
        vm.userName = vm.employee.UserName;
        onboardingDocumentService.saveComment({
            ApplicationId: vm.applicationId,
            UserName: vm.employee.UserName,
            Text: vm.commentText
        }).then(function (isSaved) {
            if (isSaved === true) {
                onboardingDocumentService.retrieveComments(vm.applicationId)
                    .then(function (comments) {
                        vm.commentText = '';
                        vm.allComments[0] = comments;
                        utilityService.hideLoading();
                    })
                    .catch((err) => {
                        utilityService.hideLoading();
                        alert("Saving Comment failed: " + utilityService.getExceptionMessage(err));
                    })
            } else {
                utilityService.hideLoading();
                alert("Saving Comment failed");
            }
            return isSaved;
        }).catch((err) => {
            utilityService.hideLoading();
            alert("Saving Comment failed: " + utilityService.getExceptionMessage(err));
        })
    }


    //function getSubmittedForm(requestTypeId, employeeId) {
    //    const taxForm = onboardingDocumentService.getTaxForm(employeeId, requestTypeId);
    //    /*return onboardingDocumentService.getTaxForm(vm.employee.UserName, requestTypeId);*/
    //    utilityService.showLoadingUntilResolved(
    //        utilityService.alertOnError(taxForm, "Download failed"))
    //        .then(() => {
    //            utilityService.hideLoading();
    //        });

    //}

    //function getSubmittedFormOwner(requestTypeId, employeeId) {
    //    const taxForm = onboardingDocumentService.getTaxForm(employeeId, requestTypeId);
    //    /*return onboardingDocumentService.getTaxForm(vm.employee.UserName, requestTypeId);*/
    //    utilityService.showLoadingUntilResolved(
    //        utilityService.alertOnError(taxForm, "Download failed"))
    //        .then(() => {
    //            utilityService.hideLoading();
    //        });

    //}
}
